// @todo make this component shared and replace groups control in statistics
import './main.less';
import React from 'react';
import PropTypes from 'prop-types';

import cloneDeep from 'lodash/cloneDeep';

import Select from '../../../shared/form-elements/select/select';

const propTypes = {
	options: PropTypes.arrayOf(
		PropTypes.shape({
			label: PropTypes.string,
			value: PropTypes.string
		})
	).isRequired,
	initialValues: PropTypes.arrayOf(
		PropTypes.shape({
			label: PropTypes.string,
			value: PropTypes.string
		})
	),
	onChange: PropTypes.func
};

const defaultProps = {
	initialValues: []
};

const typeEnum = {
	first: 'first',
	second: 'second'
};

class Groups extends React.PureComponent {
	constructor(props) {
		super(props);

		this.state = { values: this.props.initialValues };
	}

	getSelectProps(type) {
		const [ first = {}, second = {} ] = this.state.values;

		const value = type === typeEnum.first ? [first] : [second];
		const filterForOptions = entity => entity.value !== ( type === typeEnum.first ? second.value : first.value );
		const options = this.props.options.filter(filterForOptions);

		return {
			value,
			options
		};
	}

	onSelectChange(groupType, value) {
		const cloneValues = cloneDeep(this.state.values);
		const index = groupType === typeEnum.first ? 0 : 1;

		cloneValues[index] = value[0];

		this.setState({values: cloneValues}, this.fireOnChange);
	}

	onSwap() {
		const cloneValues = cloneDeep(this.state.values);

		this.setState({ values: cloneValues.reverse() }, this.fireOnChange);
	}

	fireOnChange() {
		if (this.props.onChange) {
			this.props.onChange(this.state.values);
		}
	}

	render() {
		return (
			<div className="groups-select">
				<div className="groups-select__position groups-select__position--field">
					<div className="form-element-select-improve">
						<Select
							placeholder='Select group'
							name="first"
							{...(this.getSelectProps(typeEnum.first))}
							searchable={false}
							clearable={false}
							onChange={ value => this.onSelectChange(typeEnum.first, value) } />
					</div>
				</div>
				<div className="groups-select__position groups-select__position--switch">
					<button
						className="ui-btn ui-btn-secondary groups-switch"
						onClick={() => this.onSwap()}/>
				</div>
				<div className="groups-select__position groups-select__position--field">
					<div className="form-element-select-improve">
						<Select
							placeholder='Select group'
							name="second"
							{...(this.getSelectProps(typeEnum.second))}
							searchable={false}
							clearable={false}
							onChange={ value => this.onSelectChange(typeEnum.second, value) } />
					</div>
				</div>
			</div>
		);
	}
}

Groups.propTypes = propTypes;
Groups.defaultProps = defaultProps;

export default Groups;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates-activity/components/groups/main.js